export default __webpack_public_path__ + "static/media/digi2.ae314fc3.png";